import { useCallback } from 'react';
import { useNavigate, useSearch } from '@tanstack/react-router';
import type { CampaignSearch } from './search';

export function useCampaignStabParam(fallback: string): [string, (stab: string) => void] {
  const navigate = useNavigate();
  const { stab } = useSearch({ strict: false }) as Partial<CampaignSearch>;
  const current = stab ?? fallback;
  const setStab = useCallback(
    (next: string) =>
      navigate({
        to: '.',
        search: ((p: Partial<CampaignSearch>) => ({ ...p, stab: next })),
      } as never),
    [navigate],
  );
  return [current, setStab];
}
